// Min list view dimensions
export var MIN_LIST_VIEW_WIDTH = 350;
export var MIN_LIST_VIEW_HEIGHT = 270;
// Default list view dimensions, this should be greater or equal to the minimum list view dimensions
export var DEFAULT_LIST_VIEW_WIDTH = 350;
export var DEFAULT_LIST_VIEW_HEIGHT = 270;
// Max list view dimensions allowed
export var MAX_LIST_VIEW_WIDTH = 574;
export var MAX_LIST_VIEW_HEIGHT = 535;
//# sourceMappingURL=constants.js.map